import React from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { Fire } from '@phosphor-icons/react'
import { clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

function cn(...inputs: (string | undefined | null | false)[]) {
  return twMerge(clsx(inputs))
}

interface StreakBadgeProps {
  streak: number
  className?: string
  size?: 'sm' | 'md' | 'lg'
}

export function StreakBadge({ streak, className, size = 'md' }: StreakBadgeProps) {
  // Eğer streak 0 ise gösterme
  if (streak <= 0) return null

  const sizeClasses = {
    sm: 'text-xs px-2 py-0.5 gap-1',
    md: 'text-sm px-3.5 py-1.5 gap-1.5',
    lg: 'text-base px-4 py-1.5 gap-2',
  }

  const iconSizeClasses = {
    sm: 14,
    md: 16,
    lg: 20,
  }

  // Renk mantığı: Streak arttıkça rengin canlanması
  const getColorClasses = (count: number) => {
    if (count >= 10) return 'bg-orange-500/20 text-orange-600 border border-orange-500/30 font-bold'
    if (count >= 5) return 'bg-orange-500/10 text-orange-500 font-semibold'
    return 'bg-stone-500/10 text-stone-600 font-medium'
  }

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.8 }}
        transition={{
          type: 'spring',
          stiffness: 500,
          damping: 25,
          mass: 1,
        }}
        className={cn(
          'flex items-center rounded-full',
          getColorClasses(streak),
          sizeClasses[size],
          className
        )}
      >
        <motion.div
          animate={
            streak >= 3
              ? {
                  scale: [1, 1.2, 1],
                  rotate: [0, -10, 10, -10, 0],
                }
              : {}
          }
          transition={{
            duration: 1.5,
            repeat: Infinity,
            repeatType: 'reverse',
          }}
        >
          <Fire
            size={iconSizeClasses[size]}
            className={streak >= 5 ? 'fill-current' : ''}
            weight={streak >= 5 ? 'fill' : 'regular'}
          />
        </motion.div>
        <span>{streak}</span>
      </motion.div>
    </AnimatePresence>
  )
}
